import { useManagerStateMatchesAllOf } from '../xstate/app.xstate';

export const useLoadingState = () => {
  const isFullyLoaded = useManagerStateMatchesAllOf([
    'orgRelated.ready.projects.loaded',
  ]);

  return !isFullyLoaded;
};
